"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VariableUpdateListeners = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _remeda = require("remeda");
var _fastDeepEqual = _interopRequireDefault(require("fast-deep-equal"));
var _util = require("@blockwell/util");
class VariableUpdateListeners {
  constructor(client) {
    (0, _defineProperty2.default)(this, "variables", {});
    (0, _defineProperty2.default)(this, "contracts", {});
    (0, _defineProperty2.default)(this, "activeVariable", void 0);
    (0, _defineProperty2.default)(this, "startListeners", () => {
      for (let [chainId, set] of Object.entries(this.contracts)) {
        for (let [address, entry] of Object.entries(set)) {
          let expectedFilter = null;
          if (entry.variables.length > 0) {
            let topic0s = (0, _remeda.uniq)(entry.variables.flatMap(it => this.variables[it].topics));
            if (topic0s.length > 1 || topic0s[0] === "*") {
              // More than one event, listen to everything
              expectedFilter = [];
            } else if (topic0s[0]) {
              // All for a single event, so just listen to that
              expectedFilter = [topic0s[0]];
            } else {
              // A listener for any event, so listen to everything
              expectedFilter = [];
            }
          }
          if (!(0, _fastDeepEqual.default)(expectedFilter, entry.topics)) {
            if (entry.chainListener) {
              this.client.off(entry.chainListener);
              entry.chainListener = null;
            }
            entry.topics = expectedFilter;
            if (expectedFilter) {
              entry.chainListener = this.chainListener(chainId, address);
              this.client.onLogs(chainId, {
                address,
                topics: expectedFilter
              }, entry.chainListener);
            }
          }
        }
      }
    });
    // Debouncing to deduplicate listeners for the same contract
    (0, _defineProperty2.default)(this, "debouncedListeners", (0, _util.debounce)(this.startListeners, 50, {
      maxWait: 100
    }));
    this.client = client;
  }
  chainListener(chainId, address) {
    return log => {
      let entry = this.contracts[chainId][address];
      for (let it of entry.variables) {
        let v = this.variables[it];
        if (this.shouldTrigger(log, v)) {
          v.listener(log);
        }
      }
    };
  }
  shouldTrigger(log, v) {
    var _v$topics;
    if (((_v$topics = v.topics) === null || _v$topics === void 0 ? void 0 : _v$topics.length) > 0) {
      if (v.topics[0] === "*") {
        return true;
      }
      if (!v.topics.includes(log.topics[0])) {
        return false;
      }
    }
    return true;
  }
  /**
   * Listen to updates on the chain based on events.
   *
   * You MUST set the activeIndex to the variable index first since it's used for
   * tracking, and then make sure to only call this synchronously afterwards.
   */
  listen(chainId, filter, listener) {
    let address = filter.address.toLowerCase();
    if (!this.contracts[chainId]) {
      this.contracts[chainId] = {};
    }
    if (!this.contracts[chainId][address]) {
      this.contracts[chainId][address] = {
        address,
        chainId,
        variables: [this.activeVariable]
      };
    } else {
      this.contracts[chainId][address].variables.push(this.activeVariable);
    }
    let entry = this.contracts[chainId][address];
    this.variables[this.activeVariable] = {
      entry,
      listener,
      topics: filter.topics
    };
    this.debouncedListeners();
  }
  removeListener(variable) {
    let data = this.variables[variable];
    if (data) {
      delete this.variables[variable];
      let entry = data.entry;
      entry.variables = entry.variables.filter(it => it !== variable);
      this.debouncedListeners();
    }
  }
  destroy() {
    for (let [chainId, set] of Object.entries(this.contracts)) {
      for (let [address, entry] of Object.entries(set)) {
        this.client.off(entry.chainListener);
      }
    }
    this.debouncedListeners.cancel();
    this.contracts = {};
    this.variables = {};
  }
}
exports.VariableUpdateListeners = VariableUpdateListeners;
//# sourceMappingURL=VariableUpdateListeners.js.map